import React, { useEffect, useState } from 'react';
import { listAllWebMediaOutbox } from '../offline/webMediaOutbox';
import { enqueueMediaManifestWeb } from "../offline/mediaSyncWeb";

export default function OfflineMediaOutboxPage() {
  const [items, setItems] = useState<any[]>([]);

  useEffect(() => {
    void listAllWebMediaOutbox().then(setItems).catch(() => setItems([]));
  }, []);

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold">Offline media outbox</h1>

        <button
          type="button"
          onClick={async () => {
            await enqueueMediaManifestWeb({
              mediaId: `web_media_${Date.now()}`,
              conversationId: "demo-conversation",
              recipientUserId: "demo-partner",
              mediaKind: "image",
              mimeType: "image/jpeg",
              sizeBytes: 123456,
              manifest: {
                version: 1,
                algorithm: "AES-256-GCM",
                chunks: [{ index: 0, size: 123456, nonce: "demo-nonce", ciphertextRef: "local-only" }],
                preview: { present: false },
              },
            });
            window.location.reload();
          }}
          className="rounded-xl border border-slate-700 bg-slate-900/70 px-3 py-2 text-sm text-slate-100"
        >
          Queue test manifest
        </button>
        <p className="text-sm text-slate-400">Queued encrypted image/audio/video manifests.</p>
      </div>

      {!items.length && (
        <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-4 text-sm text-slate-400">
          No queued encrypted media items.
        </div>
      )}

      {items.map((item) => (
        <div key={item.id} className="rounded-2xl border border-slate-800 bg-slate-900/40 p-4">
          <div className="font-semibold text-slate-100">
            {item.manifest?.originalFilename || item.manifest?.mediaId || 'media'}
          </div>
          <div className="text-sm text-slate-400 mt-2">kind: {String(item.manifest?.kind || 'unknown')}</div>
          <div className="text-sm text-slate-400">mime: {String(item.manifest?.mimeType || 'unknown')}</div>
          <div className="text-sm text-slate-400">retryCount: {String(item.retryCount || 0)}</div>
          <div className="text-xs text-slate-500 mt-1">
            nextAttemptAt: {item.nextAttemptAt ? new Date(item.nextAttemptAt).toISOString() : 'n/a'}
          </div>
          {!!item.lastError && <div className="text-sm text-rose-300 mt-1">lastError: {item.lastError}</div>}
        </div>
      ))}
    </div>
  );
}
